import IsEmailAvailable from '@/services/users/emailService/IsEmailAvailable';

export default class EmailService {
    /**
     * Check if the email is available.
     *
     * @param {String} email
     *
     * @returns {Promise}
     */
    isEmailAvailable(email) {
        return (new IsEmailAvailable()).handle(email);
    }
}
